import React from 'react';
import { useBusiness } from '../contexts/BusinessContext';
import BusinessSwitcher from '../components/BusinessSwitcher';
import BusinessMapTab from '../components/zones/BusinessMapTab';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';

const Home: React.FC = () => {
  const { selectedBusiness, selectedBusinessId, isLoading: businessLoading } = useBusiness();

  if (businessLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={{ xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 64px)' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 64px)' }, display: 'flex', flexDirection: 'column' }}>
      {/* Header: business switcher + at-a-glance stats */}
      <Paper
        square
        elevation={0}
        sx={{
          p: { xs: 1, sm: 2 },
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 2, sm: 4 },
          flexWrap: 'wrap',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <BusinessSwitcher />
        {selectedBusiness && (
          <Box>
            <Typography variant="caption" color="text.secondary">Devices</Typography>
            <Typography variant="h6" fontWeight={700}>{selectedBusiness.deviceCount}</Typography>
          </Box>
        )}
        <Box sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }} />
      </Paper>

      {/* Map + spatial layers */}
      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        {!selectedBusinessId ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Typography color="text.secondary">No business selected.</Typography>
          </Box>
        ) : (
          <BusinessMapTab businessId={selectedBusinessId} businessName={selectedBusiness?.name ?? ''} />
        )}
      </Box>
    </Box>
  );
};

export default Home;
